<script setup lang="ts">
import NotificationBadge from './NotificationBadge.vue'
import useUser from '../../../../../../Composables/User/useUser.ts'
import RoleEnum from '../../../../../../Constants/Role.ts'
import { computed } from 'vue'
import NotificationTabEnum from '../../../../../../Constants/NotificationTabEnum.ts'

interface Props {
  activeTab: string
  unreadCount: number
  teamUnreadCount: number
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'switch', tab: string): void
}>()

function handleTabSwitch(tab: string) {
  emit('switch', tab)
}

const { hasRole } = useUser()

const tabClass = (tab: string, activeTab: string) => [
  'flex-fill text-center py-2 fs-14 tab-item',
  { 'text-primary font-weight-bold': activeTab === tab },
]

const canViewOther = computed(() => hasRole(RoleEnum.ROLE_VIEW_OTHER))
</script>

<template>
  <div class="d-flex bg-white border-bottom">
    <span
      :class="tabClass(NotificationTabEnum.MY_TASKS, activeTab)"
      @click.stop="handleTabSwitch(NotificationTabEnum.MY_TASKS)"
    >
      {{ $t('notification.tabs.myTasks') }}
      <NotificationBadge :count="unreadCount" variant="counter" />
    </span>
    <span
      v-if="canViewOther"
      :class="tabClass(NotificationTabEnum.TEAM, activeTab)"
      @click.stop="handleTabSwitch(NotificationTabEnum.TEAM)"
    >
      {{ $t('notification.tabs.team') }}
      <NotificationBadge :count="teamUnreadCount" variant="counter" />
    </span>
  </div>
</template>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  border-bottom: 0.125rem solid transparent;

  &.text-primary {
    border-bottom-color: currentColor;
  }
}
</style>
